import { render, staticRenderFns } from "./ScoreDetailRevenueSummary.vue?vue&type=template&id=46e95e98"
import script from "./ScoreDetailRevenueSummary.vue?vue&type=script&lang=js"
export * from "./ScoreDetailRevenueSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports